import axios, { AxiosRequestConfig } from "axios";
import { loadStytch } from "@/lib/stytch.ts";

export const axiosClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const fetchApi = <T>(
  options: AxiosRequestConfig,
  authenticated: boolean = true,
) => {
  const headers = options.headers || {};

  if (authenticated) {
    const client = loadStytch();
    const tokens = client.session.getTokens();

    if (tokens?.session_token) {
      headers["Authorization"] = `${tokens?.session_jwt}`;
    }
  }

  return axiosClient.request<T>({
    ...options,
    headers,
  });
};
